import Image from 'next/image';
import React, { FC } from 'react';

import { StyledMiniatureListItem } from '@/components/elements/favorite-basket-miniature/styled';

import { TFullRentProduct } from '@/entities/product';

import { IMAGE_ALT_CUT_LENGTH, DEFAULT_IMAGE_SRC } from '@/shared/constants/settings';
import { cutString } from '@/shared/utils/string';

import * as Styled from '../styled';

type TProps = {
    product: TFullRentProduct;
    title: string;
};

export const ReservationNotification: FC<TProps> = ({ product, title }) => {
    return (
        <Styled.ReservationNotificationWrapper>
            <div className="title">{title}</div>
            <StyledMiniatureListItem>
                <Image
                    src={product.photos?.[0]?.image ?? DEFAULT_IMAGE_SRC}
                    width={42}
                    height={42}
                    alt={cutString(product.name, IMAGE_ALT_CUT_LENGTH)}
                />
                <span className="name"> {product.name} </span>
            </StyledMiniatureListItem>
        </Styled.ReservationNotificationWrapper>
    );
};
